export const px = (x: number | string | undefined): string | undefined =>
  typeof x === 'number' ? `${x}px` : x;
